import { useEffect, useRef } from "react";
import { useSelector } from 'react-redux';

/**
 * Хук, который берет на себя обязанности по управлению загрузкой. Он вызывает нужный запрос из АПИ
 * и в случае если меняется массив зависимостей посылает запрос повторно, отменив предыдущий 
 * (если он еще происходит)
 * @param {string} loaderName - имя ф-ции загрузчика в апи
 * @param {string} dataHolderName - имя переменной, хранителя результатов загрузки
 * @param {object} loadQuery - объект запроса, который мы посылаем
 * @param {boolean} startCriteria - критерий начинать ли загрузку (чаще всего цепляется к правам). Кроме того имеет смысл добавлять его в массив depedences
 * @param {Array} depedences - массив зависимостей, при изменении которого мы прерываем прошлый и посылаем новый запрос
 * @param {string?} clearerName - имя ф-ции которая позволяет очистить значение при выходе (берем в апи.actions)
 * @returns содержимое переменной имя которой нам передали в dataHolderName
 */
const useAbortableLoad = (loaderName, dataHolderName, loadQuery, startCriteria, depedences, clearerName) => {
  const loadObjRef = useRef(null);
  const loadObj = useSelector((state) => state?.api?.[dataHolderName]);
  const loader = useSelector((state) => state?.service?.Api?.[loaderName]);
  const clearer = useSelector((state) => state?.service?.Api?.actions?.[clearerName]);

  //Это нужно, чтоб внури ф-ции отмены эффекта гарантировано была свежая версия объекта загрузки
  loadObjRef.current = loadObj;

  useEffect(() => {
    if (startCriteria && loader) {
      setTimeout(()=>loader(loadQuery),0)
      // loader(loadQuery);
      return () => {
        if(loadObjRef.current?.abort) loadObjRef.current?.abort();
        if(clearer)clearer()
      }
    }
  }, depedences)

  return loadObj;
}

export default useAbortableLoad;